// extracted by mini-css-extract-plugin
export default {"authorizePage":"rematch-waiting_authorizePage__u05Fl","rematchGif":"rematch-waiting_rematchGif__HZQp6","rotate":"rematch-waiting_rotate__Dgq-i"};